import { useEffect } from 'react';
import { useAppData } from '@/contexts/AppDataContext';

const SCRIPT_MARKER = 'data-support-widget';

function readSupportMarkup(config: { widget?: { support?: unknown } } | null | undefined) {
  const support = config?.widget?.support;
  return typeof support === 'string' ? support.trim() : '';
}

function injectSupportScript(markup: string) {
  const parsed = new DOMParser().parseFromString(markup, 'text/html');
  const source = parsed.querySelector('script');
  const src = source?.getAttribute('src')?.trim();
  if (!source || !src || !/^https:\/\//i.test(src)) return;

  const existing = document.querySelector(`script[${SCRIPT_MARKER}]`);
  if (
    existing?.getAttribute('src') === src &&
    existing.getAttribute('data-widget') === source.getAttribute('data-widget') &&
    existing.getAttribute(SCRIPT_MARKER) === 'async'
  ) {
    return;
  }
  existing?.remove();

  const script = document.createElement('script');
  // defer só vale para script no HTML inicial. Inserido depois, o navegador não baixa o arquivo.
  script.async = true;
  script.setAttribute(SCRIPT_MARKER, 'async');

  for (const attr of Array.from(source.attributes)) {
    const allowed =
      attr.name === 'src' ||
      attr.name === 'type' ||
      attr.name === 'crossorigin' ||
      attr.name === 'integrity' ||
      attr.name.startsWith('data-');
    if (allowed) script.setAttribute(attr.name, attr.value);
  }

  document.body.appendChild(script);
}

export function SupportWidget() {
  const { config } = useAppData();
  const markup = readSupportMarkup(config);

  useEffect(() => {
    if (!markup) {
      document.querySelector(`script[${SCRIPT_MARKER}]`)?.remove();
      return;
    }
    injectSupportScript(markup);
  }, [markup]);

  return null;
}
